import { render, staticRenderFns } from "./appSms.vue?vue&type=template&id=2dd8d000&scoped=true&"
import script from "./appSms.vue?vue&type=script&lang=js&"
export * from "./appSms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd8d000",
  null
  
)

export default component.exports